/**
 * Hands `text` to the browser as a file download. The bytes are the
 * server's, unchanged (the export is the JSON document itself,
 * account_lifecycle.go:244-249), so the file matches what was sent.
 */
export function saveTextFile(text: string, filename: string, type = "application/json"): void {
  const blob = new Blob([text], { type });
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    // Revoke after the click has been dispatched; the download keeps its own reference.
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}
